export enum EnumTipoPrazoDocumentoAssDigital {
    UM_DIA = "UM_DIA",
    TRES_DIAS = "TRES_DIAS",
    CINCO_DIAS = "CINCO_DIAS",
    SETE_DIAS = "SETE_DIAS",
    DEZ_DIAS = "DEZ_DIAS",
    QUINZE_DIAS = "QUINZE_DIAS",
    TRINTA_DIAS = "TRINTA_DIAS",
    INDETERMINADO = "INDETERMINADO",
}

export const getPrazoFormatado = (tipoPrazo: EnumTipoPrazoDocumentoAssDigital) => {
    switch (tipoPrazo) {
        case EnumTipoPrazoDocumentoAssDigital.UM_DIA:
            return '1 dia';
        case EnumTipoPrazoDocumentoAssDigital.TRES_DIAS:
            return '3 dias';
        case EnumTipoPrazoDocumentoAssDigital.CINCO_DIAS:
            return '5 dias';
        case EnumTipoPrazoDocumentoAssDigital.SETE_DIAS:
            return '7 dias';
        case EnumTipoPrazoDocumentoAssDigital.DEZ_DIAS:
            return '10 dias';
        case EnumTipoPrazoDocumentoAssDigital.QUINZE_DIAS:
            return '15 dias';
        case EnumTipoPrazoDocumentoAssDigital.TRINTA_DIAS:
            return '30 dias';
        case EnumTipoPrazoDocumentoAssDigital.INDETERMINADO:
            return 'Indeterminado';
        default:
            return tipoPrazo;
    }
};
